import { RestaurantReferralStatus } from '@vgrubs/components';
import { DateTime } from 'luxon';

/** The status tabs over the list. `null` is every status. */
export const REFERRAL_TABS: {
  value: RestaurantReferralStatus | null;
  label: string;
}[] = [
  { value: null, label: 'All' },
  { value: 'signedUp', label: 'Signed up' },
  { value: 'live', label: 'Live' },
  { value: 'earned', label: 'Earned' },
  { value: 'expired', label: 'Expired' },
];

export const formatReferralDay = (iso: string | null | undefined) =>
  iso ? DateTime.fromISO(iso).toFormat('MMM d, yyyy') : '-';
